import FormInput from '@form/FormInput';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@ui';
import { cn } from '~/lib/cn';
import { HTMLAttributes } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Module } from '../../../types';
import useVoucherValidation from './useVoucherValidation';
import VoucherCards from './VoucherCards';

interface Props extends HTMLAttributes<HTMLDivElement> {
    type: Module;
    /** false leaves the booker's saved vouchers out, so a caller can place them itself */
    showCards?: boolean;
}

const VoucherFields = ({ type, className, showCards = true, ...props }: Props) => {
    const { t } = useTranslation('voucher');
    const { watch } = useFormContext();
    const { validate, validateResult, isInvalid, isLoading, renderVoucherValue } = useVoucherValidation(type);

    const space_voucher_card_id = watch('space_voucher_card_id');

    if (space_voucher_card_id) return null;

    return (
        <div className={cn('tw-my-4', className)} {...props}>
            <div className="tw-flex tw-items-center tw-gap-2">
                <FormInput flush name="voucher_code" className="tw-flex-1" placeholder={t('fields.codePlaceholder')} />
                <Button type="button" isLoading={isLoading} disabled={!!validateResult} onPress={() => validate()}>
                    {validateResult ? <FontAwesomeIcon icon={faCheck} /> : t('fields.checkButton')}
                </Button>
            </div>
            {(isInvalid || !!validateResult) && (
                <span className={cn(isInvalid ? 'tw-text-error' : 'tw-text-success', 'tw-pl-2 tw-text-xs tw-italic')}>
                    {isInvalid ? t('fields.invalidCode') : t('fields.recognizedApplied', { value: renderVoucherValue })}
                </span>
            )}
            {showCards && <VoucherCards className="tw-mt-2" type={type} />}
        </div>
    );
};

export default VoucherFields;
